import * as React from 'react';

import '@progress/kendo-theme-default/dist/all.css';
import './kendo.css'
import { Splitter, SplitterOnChangeEvent, BreadcrumbLinkMouseEvent } from '@progress/kendo-react-layout';
import { useInternationalization } from '@progress/kendo-react-intl';
import { process, SortDescriptor, State } from '@progress/kendo-data-query';
import { clone, getter } from '@progress/kendo-react-common';
import { GridRowDoubleClickEvent, GridRowClickEvent, getSelectedState } from '@progress/kendo-react-grid';
import { TreeViewItemClickEvent } from '@progress/kendo-react-treeview';
import { InputChangeEvent } from '@progress/kendo-react-inputs';
import {Offset, Popup} from '@progress/kendo-react-popup';

import { FileManagerToolbar } from './components/FileManagerToolbar';
import { GridView } from './components/GridView';
import { FileInformation } from './components/FileInformation';
import { FolderTree } from './components/FolderTree';
import { BreadcrumbComponent } from './components/Breadcrumb';
import { DeleteDialog, EditDialog } from './components/Dialog';
import download from 'downloadjs';

import {
    Alert,
    Grid,
    Menu,
    MenuItem,
} from "@mui/material";

import {
    DataModel,
    PanesModel,
    SelectedItemType,
    SortChangeEvent,
    AppSwitchChangeEvent,
    ContextMenuEvent, UploadAddEvent, ViewChangeEvent
} from './interfaces/FileManagerModels';
import {
    formatData,
    getFolderTree,
    searchTreeItem,
    addFolder,
    addDataItem,
    convertExtensionToIcon,
    convertToBreadcrumbData,
    removeDataItem,
    editDataItem,
    getFolderPath,
    addDataItemWithPath,
    editDataItemName,
    searchTreeItemPath,
    searchTreeItemForValue,
} from './helpers/helperMethods';
import {useEffect} from "react";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import {useCopyDocuments, useDeleteDocuments, useMoveDocuments, useUploadDocument} from "../../queries/useDocuments";
import axios from "axios";
import styles from "../FileViewerPage/Documents/DocumentsFileViewerPage.module.css";
import Alerts from "../../components/common/Alerts";
import Dropzone, {DropzoneRef} from "react-dropzone";
import {Button, Dialog, DialogActions, DialogContent, DialogContentText} from "@material-ui/core";
import PdfViewerComponent from "../../components/PdfViewerComponent";
import {EditDescriptor} from "@progress/kendo-react-data-tools/index";
import Snackbar from "@mui/material/Snackbar";
import {getConfig} from "../../AppConfig";
import {UploadFileInfo} from "@progress/kendo-react-upload";

const splitterPanes: PanesModel[] = [
    {
        size: '20%',
        min: '20px',
        collapsible: true,
    },
    {},
    {
        size: '30%',
        min: '20px',
        collapsible: true,
    },
];

const initialSort: SortDescriptor[] = [{
    field: 'path',
    dir: 'asc'
}];

const DATA_ITEM_KEY = 'id';
const SELECTED_FIELD = 'selected';
const idGetter = getter(DATA_ITEM_KEY);

export const ColumnFileViewer = ({columnStructure, isLoading, setIsLoading, woid, reloadColumnViewer}) => {
    const { secretkey } = getConfig()
    const intl = useInternationalization();
    const dropzoneRef = React.createRef<DropzoneRef>()
    const [stateDataOriginal, setStateDataOriginal] = React.useState<DataModel[]>(formatData(columnStructure, intl));
    const [stateData, setStateData] = React.useState<DataModel[]>(formatData(columnStructure, intl));
    const [searchData, setSearchData] = React.useState<DataModel[]>(null);
    const [panes, setPanes] = React.useState<PanesModel[]>(splitterPanes);
    const [selectedGridItem, setSelectedGridItem] = React.useState<DataModel>({});
    const [selectedTreeItem, setSelectedTreeItem] = React.useState<DataModel | null>(null);
    const [gridSelection, setGridSelection] = React.useState<{ [id: string]: boolean | number[]; }>({});
    const [copyDateItem, setCopyDataItem] = React.useState(null)
    const [moveDataItem, setMovDataItem] = React.useState(false)
    const [contentView, setContentView] = React.useState<string>('grid');
    const [detailsData, setDetailsData] = React.useState<null | number | Object>(null);
    const [contextMenuView, setContextMenuView] = React.useState<boolean>(false);
    const [menuOffSet, setMenuOffSet] = React.useState<Offset>({ left: 0, top: 0 });
    const [editDialogView, setEditDialogView] = React.useState<boolean>(false);
    const [deleteDialogView, setDeleteDialogView] = React.useState<boolean>(false);
    const [watchLogoData, setWatchLogoData] = React.useState(null)
    const [watchLogoDataURL, setWatchLogoDataURL] = React.useState(null)
    const [edit, setEdit] = React.useState<EditDescriptor>({});
    const [openViewer, setOpenViewer] = React.useState(false)
    const [saveDocument, setSaveDocument] = React.useState(0)
    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const [allDataItems, setAllDataItems] = React.useState([])
    const [dialogMsg, setDialogMsg] = React.useState("")
    const moveDocument = useMoveDocuments(woid)
    const copyDocument = useCopyDocuments(woid)
    const uploadDocument = useUploadDocument(woid)
    const deleteDocument = useDeleteDocuments(woid)
    const [files, setFiles] = React.useState<UploadFileInfo[]>([]);

    const initialLogic: 'and' | 'or' = 'and';

    const [stateContentData, setStateContentData] = React.useState<State>({
        sort: initialSort,
        filter: {
            logic: initialLogic,
            filters: [
                { field: 'path', operator: 'contains', value: '' },
                { field: 'name', operator: 'contains', value: '' }
            ]
        }
    });

    const saveDocumentCallback = (documentItem) => {
        const mimeType = getMimeType(documentItem.name)

        const formData = new FormData();
        formData.append('file', documentItem.blob, 'document.pdf');
        formData.append('GUID', '');
        formData.append('filename', documentItem.name);
        formData.append('id', documentItem.id);
        formData.append('woid', documentItem.woid);
        if (documentItem?.IsSaveAsBuilt != null) {
            formData.append('IsSaveAsBuilt', documentItem.IsSaveAsBuilt);
        }
        if (documentItem?.sharedid) {
            formData.append('SharedId', documentItem.sharedid);
        }
        formData.append('mimetype', mimeType);

        axios.put(`api/documentsbloboverwrite`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        }).then((response) => {
            console.log(response)

            documentItem.setLoadingBackdrop(false)
        })
    }

    const updateFileDetailsData = React.useCallback(
        (selection: SelectedItemType) => {
            if (selection.path) {
                const newSelectedItem = searchTreeItem(stateData, selection)
                setDetailsData(newSelectedItem);
            } else if (!selection.path && Object.keys(selection).length) {
                setDetailsData(Object.keys(selection).length);
            }
            else {
                setDetailsData(null);
            }
        },
        [stateData]
    );

    const handleTreeItemClick = (event: TreeViewItemClickEvent) => {
        const newSelectedItem: DataModel = searchTreeItem(stateData, event.item);
        newSelectedItem.expanded = !event.item.expanded;

        setSelectedTreeItem(newSelectedItem);
        setSearchData(null)
        setDetailsData(event.item);
        setSelectedGridItem({});
        setGridSelection({});
    };

    const handleSplitterChange = (event: SplitterOnChangeEvent) => {
        setPanes(event.newState);
    };

    const handleSelectionChange = (event: GridRowClickEvent) => {
        if (!event.dataItem.isfolder) {
            setSelectedGridItem(event.dataItem);
            updateFileDetailsData(event.dataItem);
        }
    }

    const handleMultipleSelection = (event) => {
        setAllDataItems(event.dataItems)
        event.dataItems.forEach((item, index) => {
            if (index >= event.startRowIndex && index <= event.endRowIndex) {
                if (!event.dataItems[event.startRowIndex].isfolder) {
                    const newSelection = getSelectedState({
                        event,
                        selectedState: gridSelection,
                        dataItemKey: DATA_ITEM_KEY
                    });

                    setGridSelection(newSelection);
                }
            }
        })
    }

    const handleSortChange = (event: SortChangeEvent) => {
        const newSortedData = clone(stateContentData);

        if (event.direction === 'asc' || event.direction === 'desc') {
            newSortedData.sort[0].dir = event.direction;
        }

        if (event.item) {
            newSortedData.sort[0].field = event.item.value;
        }

        if (event.sort) {
            newSortedData.sort = event.sort;
        }
        setStateContentData(newSortedData);
    };

    useEffect(() => {
        console.log(selectedTreeItem)
    }, [selectedTreeItem])

    useEffect(() => {
        if (stateData && stateData?.length > 0 && !selectedTreeItem) {
            stateData[0].expanded = true
            setSelectedTreeItem(stateData[0])
        }
        else {
            // console.log(stateData)
            // storeExpanded(stateData)
        }
    }, [stateData])

    const handleSaveEdit = (event) => {
        const folderPath = getFolderPath(event.dataItem.path);
        const newPath = `${folderPath}/${event.value}`
        const curItem: DataModel | null = Object.keys(selectedGridItem).length ? selectedGridItem : selectedTreeItem;

        // const existingItem = searchTreeItemPath(stateData, { path: newPath });
        // if (!existingItem) {
        const updatedData = editDataItemName(stateData, curItem, newPath, event.value, intl);
        setSelectedTreeItem(searchTreeItem(updatedData, {id: event.dataItem.parentid}));
        setStateData(updatedData);

        const body = {
            FileOrFolderId: event?.dataItem?.id,
            NewName: event.value,
            sharedid: event?.dataItem?.sharedid,
        }
        axios.post(`api/documentsrename`, body).then((response) => {
        })
        // }
        setEdit((edit) => ({ ...edit, [event.dataItem.id!]: false }));
    }
    const handleCancelEdit = (event) => {
        setEdit((edit) => ({ ...edit, [event.dataItem.id!]: false }));
    }


    const handleGridDoubleClick = (event: GridRowDoubleClickEvent) => {
        const itemType = convertExtensionToIcon(event.dataItem.path);
        if (event?.dataItem.isfolder) {
            if (selectedTreeItem) {
                selectedTreeItem.expanded = true;
            }

            const newSelectedItem = event.dataItem;
            newSelectedItem.expanded = true;
            setSelectedTreeItem(searchTreeItem(stateData, newSelectedItem));
        }
        else {
            // Check if file is a spreadsheet
            const extension = selectedGridItem?.name?.split('.').pop()?.toLowerCase();
            const isSpreadsheet = ['xls', 'xlsx', 'csv'].includes(extension);

            var urlTOOpen = isSpreadsheet ? '/filesystem/spreadsheet/' : '/filesystem/pdfpage/'
            urlTOOpen += selectedGridItem?.id + '/' + woid

            var CryptoJS = require("crypto-js");
            var encriptedString = CryptoJS.AES.encrypt(JSON.stringify({
                driveid: selectedGridItem?.id,
                save: selectedGridItem?.allowsave,
                woid: woid,
                readonly: false,
                issaveasbuilt: selectedGridItem?.issaveasbuilt,
                filename: selectedGridItem?.name,
                mimetype: getMimeType(selectedGridItem?.name)
            }), secretkey).toString();

            localStorage.setItem('pdfopen-' + selectedGridItem?.id, encriptedString)

            if (selectedGridItem.id && selectedGridItem.id.length > 0) {
                // urlTOOpen += '/' + encodeURIComponent(encriptedString)
                localStorage.setItem('pdfopen-' + selectedGridItem?.id + '-' + woid, encriptedString)
            }
            window.open(urlTOOpen)
        }
    };

    const generateUniqueFolderName = () => {
        return `New Folder (${intl.formatDate(new Date(), 'MM.d.y  h:mm:ss')})`;
    };

    const handleDownloadClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        setIsLoading(true)
        const selectedKeys = Object.keys(gridSelection)
        const itemsToDownload = selectedKeys.map(key => {
            const oneItem = allDataItems.find(dataItem => dataItem.id === key)
            return {
                "Id": oneItem.id,
                "Name": oneItem.name
            }
        })
        const body = {
            "woid": woid,
            "files": itemsToDownload
        }
        axios.post(`api/documentsbulkfile`, body, {responseType: "blob"}).then((response) => {
            var filename = 'files.zip';
            var disposition = response.headers['content-disposition']
            var contentType = response.headers['content-type']
            if (disposition) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
            }
            if (response.data) {
                download(response.data, filename, contentType);
            }

            setIsLoading(false)
        })

    }

    const handleNewFolderClick = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        let newData;
        const folderName = generateUniqueFolderName()
        if (selectedTreeItem) {
            const body = {
                FolderName: folderName,
                Woid: woid,
                ParentFolderId: selectedTreeItem.id,
                SharedId: selectedTreeItem.sharedid
            }

            axios.post(`api/documentsfoldercreate`, body).then((response) => {
                const parsedData = JSON.parse(response.data.jsonString)
                if (parsedData?.status ===  'failure') {
                    setSnackbarOpen( { open: true, message: parsedData?.message})
                }
                else {
                    // newData = addFolder(parsedData.contents[0].Id, stateData, selectedTreeItem, folderName, intl);
                    var newContent = selectedTreeItem
                    if (parsedData?.contents && parsedData?.contents?.length > 0) {
                        newContent = {
                            ...selectedTreeItem,
                            issaveasbuilt: parsedData.contents[0].IsSaveAsBuilt,
                            issystem: parsedData.contents[0].IsSaveAsBuilt,
                            path: selectedTreeItem.path,
                            parentid: parsedData.contents[0].ParentId,
                            sharedid: parsedData.contents[0].SharedId,
                            Thumbnail: parsedData.contents[0].Thumbnail,
                            allowfolder: parsedData.contents[0].allowfolder,
                            allowdelete: parsedData.contents[0].allowdelete,
                            allowsave: parsedData.contents[0].allowsave,
                            allowcopy: parsedData.contents[0].allowcopy,
                            allowmove: parsedData.contents[0].allowmove,
                            allowpaste: parsedData.contents[0].allowpaste,
                            allowrename: parsedData.contents[0].allowrename,
                            allowdownload: parsedData.contents[0].allowdownload,
                            allowupload: parsedData.contents[0].allowupload,
                        }
                        debugger
                    }
                    newData = addFolder(parsedData.contents[0].Id, stateData, newContent, folderName, intl);
                    setStateData(newData);
                }
            })
        }
    };

    const handleSearchChange = (event: InputChangeEvent) => {
        debugger
        let value = event.value;
        var newItems: DataModel[] = [];

        if (value && value?.length > 0) {
            searchTreeItemForValue(newItems, selectedTreeItem ? [selectedTreeItem] : stateDataOriginal, value)
            setSearchData(newItems)
            // setSelectedTreeItem(null)
        }
        else {

            if (stateDataOriginal && stateDataOriginal?.length > 0 && !selectedTreeItem) {
                stateData[0].expanded = true
                // setSelectedTreeItem(stateData[0])
            }
            else {
                stateData[0].expanded = true
                stateDataOriginal[0].expanded = true
            }

            setStateData(stateDataOriginal)
            setSearchData(null)
        }
    };

    const handleSwitchChange = (event: AppSwitchChangeEvent) => {
        const newPanes: PanesModel[] = panes.slice(0)
        if (event.value) {
            newPanes[2].size = '30%';
            setPanes(newPanes)
        } else {
            newPanes[2].size = '0%';
            setPanes(newPanes)
        }
    };

    const handleBreadcrumbSelection = (event: BreadcrumbLinkMouseEvent) => {
        setSelectedGridItem({});
        setGridSelection({});

        if (!event.nativeEvent.keyCode) {
            const newItem = searchTreeItemPath(stateData, { path: event.id });
            setSelectedTreeItem(newItem);
        }

        if (event.nativeEvent.keyCode === 13) {
            const newItem = searchTreeItemPath(stateData, { path: event.id });
            setSelectedTreeItem(newItem);
        }
    };


    const getMimeType = (filepath) => {
        const extension: string | null = filepath.split('.').length > 1 ? filepath.split('.')[1] : null;
        var contentType = 'image/png';
        if (extension === 'png') {
            contentType = 'image/png'
        }
        else if (extension === 'pdf') {
            contentType = 'application/pdf'
        }
        else if (extension === 'jpg' || extension === 'jpeg') {
            contentType = 'image/jpeg'
        }
        else if (extension === 'docx') {
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
        else if (extension === 'xlsx') {
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
        else if (extension === 'xls') {
            contentType = 'application/vnd.ms-excel'
        }
        return contentType
    };

    const handleDialogClick = (event) => {
        if (event.type === 'cancel') {
            setDeleteDialogView(false);
            setEditDialogView(false);
        }

        const curItem: DataModel | null = Object.keys(selectedGridItem).length ? selectedGridItem : selectedTreeItem;
        if (!curItem) { return; }

        if (event.type === 'delete') {
            const newItem: string = curItem.path || '';
            const oldPath = newItem.split('/');

            oldPath.pop();

            const updatedData = removeDataItem(stateData, curItem);
            let newItemPath = oldPath.join('/');

            setSelectedTreeItem(searchTreeItem(updatedData, { path: newItemPath }));
            setStateData(updatedData);
            setDeleteDialogView(false);
        }

        if (event.type === 'rename') {
            const folderPath = getFolderPath(event.path);
            const newPath = `${folderPath}/${event.value}`

            const existingItem = searchTreeItem(stateData, { path: newPath });
            if (!existingItem) {
                const updatedData = editDataItem(stateData, curItem, newPath);
                setSelectedTreeItem(searchTreeItem(updatedData, {path: folderPath}))
                setStateData(updatedData);

                const body = {
                    parentFolderID: event?.dataItem?.parentid, // Folder the file is dropped on
                    sharedid: event?.dataItem?.sharedid,
                    id: event?.dataItem?.id,
                    rootFolderName: getFolderPath(event?.dataItem?.path), // root folder name
                    filename: event?.value,
                    // filedata: data.split(';base64,')[1],
                    woid: woid,
                    mimetype: getMimeType(event?.dataItem?.name),
                    GUID: "",
                }
                console.log(body)
                //
                axios.put(`api/documentsfile`, body).then((response) => {
                })
            }
            setEditDialogView(false);
        }
    };

    const handleListItemClick = (event) => {
        let newSelectedGridItem = {};
        if (event?.dataItem?.path) {
            newSelectedGridItem = event.dataItem;
            newSelectedGridItem[event.dataItem.path] = true;
            newSelectedGridItem['selected'] = true;

            setSelectedGridItem(newSelectedGridItem);
            if (event.dataItem.path) {
                const key = event.dataItem.id.toString();
                setGridSelection({ [key]: true });
            }
        }

        if (event.tree) {
            const newSelectedTreeItem: DataModel = searchTreeItem(stateData, newSelectedGridItem);
            setSelectedTreeItem(newSelectedTreeItem);
        }
        updateFileDetailsData(newSelectedGridItem);
    };


    const handleContextMenuViewTree = (event: ContextMenuEvent) => {
        event.event.stopPropagation()
        event.event.preventDefault()
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.event.clientX + 2,
                    mouseY: event.event.clientY - 6,
                    dataItem: event?.dataItem ? event.dataItem : selectedTreeItem,
                    istreeitem: event?.istreeitem
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                  // Other native context menus might behave different.
                  // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        )

        setContextMenuView(true);
        setMenuOffSet({ left: event.event.clientX, top: event.event.clientY });
        handleListItemClick(event);
    };
    const handleContextMenuView = (event: ContextMenuEvent) => {
        event.event.stopPropagation()
        event.event.preventDefault()
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.event.clientX + 2,
                    mouseY: event.event.clientY - 6,
                    dataItem: event?.dataItem ? event.dataItem : selectedTreeItem,
                    istreeitem: false,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
                  // Other native context menus might behave different.
                  // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        )

        setContextMenuView(true);
        setMenuOffSet({ left: event.event.clientX, top: event.event.clientY });
        handleListItemClick(event);
    };

    const handleDialogClose = () => {
        setDeleteDialogView(false);
        setEditDialogView(false);
    };

    document.addEventListener('click', () => {
        setContextMenuView(false);
    });

    const [contextMenu, setContextMenu] = React.useState<{
        mouseX: number;
        mouseY: number;
        dataItem: any;
        istreeitem: boolean;
    } | null>(null);

    const handleClose = () => {
        setContextMenu(null);
    }

    const handleCopy = () => {
        setCopyDataItem(contextMenu.dataItem)
        setContextMenu(null);
    }

    const handleMove = () => {
        setCopyDataItem(contextMenu.dataItem)
        setMovDataItem(true)
        setContextMenu(null);
    }

    const handlePaste = () => {
        setIsLoading(true)
        const dataitem = copyDateItem

        debugger

        const body = {
            id: dataitem.id,
            toid: contextMenu.dataItem.id,
            sharedid: contextMenu.dataItem.sharedid,
        }

        if (moveDataItem) {
            moveDocument.mutateAsync(body).then((res) => {
                setIsLoading(false)
                const updatedData = removeDataItem(stateData, copyDateItem);
                dataitem.path = selectedTreeItem.path
                const newData: DataModel | any = addDataItemWithPath(updatedData, selectedTreeItem, [dataitem], dataitem.path, intl);
                setStateData(newData);
            })
            setMovDataItem(false)
            setCopyDataItem(null)
            setContextMenu(null)
        }
        else {
            copyDocument.mutateAsync(body).then((res) => {
                copyPasteGridItem(contextMenu.dataItem, dataitem)
                setIsLoading(false)
            })
            setMovDataItem(false)
            setCopyDataItem(null)
            setContextMenu(null)
        }
    }

    const copyPasteGridItem = (gridItemOld, gridItemNew) => {
        gridItemNew.path = selectedTreeItem.path
        const newData: DataModel | any = addDataItemWithPath(stateData, selectedTreeItem, [gridItemNew], gridItemNew.path, intl);

        setStateData(newData);
    }

    const handleRename = () => {
        if (contextMenu?.istreeitem) {
            selectedTreeItem.edit = true;
            setContextMenu(null);
        }
        else {
            setSelectedGridItem(contextMenu.dataItem)
            if (contextMenu.dataItem.path) {
                const key = contextMenu.dataItem.parentid.toString();
                setGridSelection({ [key]: true });
            }
            setEdit((edit) => ({ ...edit, [contextMenu.dataItem.id!]: true }));
            setContextMenu(null);
        }
    }

    const handleDownload = () => {
        setIsLoading(true)
        const body = {
            id: contextMenu.dataItem.id,
            filename: contextMenu.dataItem.name,
            sharedid: contextMenu.dataItem.sharedid,
        }
        const fileName = contextMenu.dataItem.name
        axios.post(`api/documentsfile`, body).then((response) => {
            const dataJson = JSON.parse(response.data.jsonString)
            if (dataJson.status === "success") {
                setWatchLogoData(dataJson.filedata)
                var contentType = 'image/png';
                if (dataJson.fileext === '.png') {
                    contentType = 'image/png'
                }
                else if (dataJson.fileext === '.pdf') {
                    contentType = 'application/pdf'
                }
                else if (dataJson.fileext === '.jpg' || dataJson.fileext === '.jpg') {
                    contentType = 'image/jpeg'
                }
                else if (dataJson.fileext === '.docx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                }
                else if (dataJson.fileext === '.xlsx') {
                    contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                }
                else if (dataJson.fileext === '.xls') {
                    contentType = 'application/vnd.ms-excel'
                }
                debugger
                const byteCharacters = atob(dataJson.filedata)
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);
                const blob = new Blob([byteArray], {type: contentType});
                const url = window.URL.createObjectURL(blob);
                setWatchLogoDataURL(url);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", fileName); //or any other extension
                document.body.appendChild(link);
                link.click();
            }
            else {
                setDialogMsg(dataJson.message)
            }

            setIsLoading(false)
        })

        setContextMenu(null);
    }

    const closeDialog = () => {
        setDialogMsg("")
    }
    const handleDelete = () => {
        setIsLoading(true)
        const body = {
            id: contextMenu.dataItem.id,
            filename: contextMenu.dataItem.name,
            sharedid: contextMenu.dataItem.sharedid,
        }
        deleteDocument.mutateAsync(body).then((response) => {
            setIsLoading(false)
        })

        const updatedData = removeDataItem(stateData, selectedGridItem);
        setStateData(updatedData);
        setSelectedTreeItem(searchTreeItem(updatedData, { id: contextMenu.dataItem.parentid }));
        setContextMenu(null);
    }


    const handleSnackbarClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    function HumanReadableDate(isoDateString) {
        if (isoDateString === null) {
            return null
        }
        const date = new Date(isoDateString);
        // Check if the date is valid
        if (isNaN(date.getTime())) {
            // Return a default message or handle the error as needed
            return null;
        }
        const options: Intl.DateTimeFormatOptions = {
            year: 'numeric', // Correct type
            month: '2-digit', // Correct type
            day: '2-digit', // Correct type
            hour: '2-digit', // Correct type
            minute: '2-digit', // Correct type
            timeZoneName: 'short', // Correct type
            hour12: false // Correctly expecting a boolean
        };
        const formattedDate = new Intl.DateTimeFormat('en-US', options).format(date);

        return formattedDate;
    }


    const onSave = (event: any, files: File[], tree: any, topFolderName: any) => {
        setIsLoading(true)
        files.map((file) => {
            const fileReader = new FileReader()
            fileReader.onload = function (event) {
                const data = event.target.result as string
                const body = {
                    parentFolderID: tree ? tree.id : columnStructure[0].id, // Folder the file is dropped on
                    sharedid: tree ? tree.sharedid : columnStructure[0].sharedid,
                    // id: tree.Id,
                    rootFolderName: topFolderName, // root folder name
                    filename: file.name,
                    filedata: data.split(';base64,')[1],
                    woid: woid,
                    mimetype:  file.type,
                    GUID: "",
                }

                axios.put(`api/documentsfile`, body).then((response) => {
                    console.log(response)
                    debugger
                    const data = JSON.parse(response.data.jsonString)
                    console.log(data)

                    if (data.status === 'failure') {
                        setIsLoading(false)
                        setSnackbarOpen( { open: true, message: data.message})
                    }
                    else {
                        const newFiles = [{
                            name: data.contents[0].Name,
                            extension: data.contents[0].Name,
                            size: data.contents[0].Size,
                            id: data.contents[0].Id,
                            dateCreated: HumanReadableDate(data.contents[0].CreatedTime),
                            dateModified: HumanReadableDate(data.contents[0].ModifiedTime),
                            parentid: data.contents[0].ParentId,
                            isfolder: data.contents[0].IsFolder,
                            sharedid: data.contents[0].SharedId,
                            issystem: data.contents[0].IsSystem,
                            issaveasbuilt: data.contents[0].IsSaveAsBuilt,
                            allowfolder: data.contents[0].allowfolder,
                            allowdelete: data.contents[0].allowdelete,
                            allowsave: data.contents[0].allowsave,
                            allowcopy: data.contents[0].allowcopy,
                            allowmove: data.contents[0].allowmove,
                            allowpaste: data.contents[0].allowpaste,
                            allowrename: data.contents[0].allowrename,
                            allowdownload: data.contents[0].allowdownload,
                            allowupload: data.contents[0].allowupload,
                            // Thumbnail: data.contents[0].Thumbnail,
                        }]
                        var selectedItem = {...tree}

                        if (!selectedItem?.id) {
                            selectedItem = {...columnStructure[0]}
                        }
                        const newData: DataModel | any = addDataItemWithPath(stateData, selectedItem, newFiles, selectedItem.path, intl);
                        // queryClient.invalidateQueries(['gdwodocuments', woid])
                        setStateData(newData);
                    }
                    setIsLoading(false)
                })
            }
            fileReader.readAsDataURL(file)
        })

        // event.stopPropagation()
    }

    const getGridData = () => {
        debugger
        var gridDataTemp = null
        if (searchData != null) {
            gridDataTemp = process((searchData.map(item => ({
                    ...item,
                    [SELECTED_FIELD]: gridSelection[idGetter(item)],
                })))
                , stateContentData)
        }
        else if (selectedTreeItem && selectedTreeItem.items) {
            gridDataTemp = process((selectedTreeItem.items.map(item => ({
                    ...item,
                    [SELECTED_FIELD]: gridSelection[idGetter(item)],
                })))
                , stateContentData)
        }
        else {
            gridDataTemp = process((stateData.map(item => ({
                    ...item,
                    [SELECTED_FIELD]: gridSelection[idGetter(item)],
                })))
                , stateContentData)
        }
        // else {
        //     gridDataTemp = null
        // }
        return gridDataTemp
    }

    const handleViewChange = (event: ViewChangeEvent) => {
        if (event.viewValue.gridView) {
            setContentView('grid');
        }
        if (event.viewValue.listView) {
            setContentView('list');
        }
    };

    const handleFileChange = (event: UploadAddEvent) => {
        if (event.files) {
            setFiles(event.files);
        }
    };

    const handleClearFileList = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        if (event) {
            setFiles([]);
        }
    };

    const handleUploadComplete = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        const newData: DataModel | any = addDataItem(stateData, selectedTreeItem, files, intl);

        setStateData(newData);
        setFiles([]);
    };


    const getGridView = () => (
        <GridView
            data={getGridData()}
            edit={edit}
            setEdit={setEdit}
            sort={stateContentData.sort}
            dataItemKey={DATA_ITEM_KEY}
            onSelectionChange={handleSelectionChange}
            onMultipleSelection={handleMultipleSelection}
            onSortChange={handleSortChange}
            onDoubleClick={handleGridDoubleClick}
            onContextMenu={handleContextMenuView}
            onCancelRename={handleCancelEdit}
            onSaveRename={handleSaveEdit}
        />
    )


    return (
        <div>
            <LoadingBackdrop open={isLoading} />
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleSnackbarClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="error">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <>
                    <Dialog
                        open={dialogMsg.length > 0}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                {dialogMsg}
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={closeDialog}>Ok</Button>
                        </DialogActions>
                    </Dialog>
                </>
            </>
            {/*{!isLoading &&*/}
            <div hidden={isLoading} className='k-widget k-filemanager k-filemanager-resizable'>
                <div className='k-filemanager-header'>
                    <FileManagerToolbar
                        sort={stateContentData.sort}
                        onNewFolderClick={handleNewFolderClick}
                        handleDownloadClick={handleDownloadClick}
                        onSearchChange={handleSearchChange}
                        onSwitchChange={handleSwitchChange}
                        onSortChange={handleSortChange}
                        // onUploadComplete={handleUploadComplete}
                        onClearFileList={handleClearFileList}
                        onUploadComplete={handleUploadComplete}
                        onFilesSelected={(files) => onSave({} as any, Array.from(files), selectedTreeItem, selectedTreeItem?.rootname)}
                        selectedGridItem={selectedGridItem}
                        selectedTreeItem={selectedTreeItem}
                        gridSelection={gridSelection}
                        searchData={searchData}
                    />
                </div>
                <div className='k-filemanager-content-container'>
                    <Splitter
                        panes={panes}
                        onChange={handleSplitterChange}
                        // style={{height: '600px'}}
                    >
                        <FolderTree
                            data={getFolderTree(stateData, selectedTreeItem)}
                            selected={selectedTreeItem}
                            selectedItem={selectedTreeItem}
                            onItemClick={handleTreeItemClick}
                            onContextMenu={handleContextMenuViewTree}
                            onSaveRename={handleSaveEdit}
                        />

                        {/*<div className='k-filemanager-content' style={{height: '100%'}}>*/}
                        <div className='k-filemanager-content' >
                            <BreadcrumbComponent
                                data={convertToBreadcrumbData(selectedTreeItem)}
                                onBreadcrumbSelect={handleBreadcrumbSelection}
                            />
                            <div className={'k-filemanager-grid k-grid-display-block k-editable'} >
                                {selectedTreeItem?.allowupload ?
                                    <Dropzone key={'test'} onDrop={(files, rejects, e) => {onSave(e, files, selectedTreeItem, selectedTreeItem?.rootname)}} noClick={false}>
                                        {({ getRootProps,
                                              getInputProps,
                                              isDragActive,
                                              isDragAccept,
                                              isDragReject,
                                              acceptedFiles,
                                              open,
                                              fileRejections,
                                          }) => (
                                            <div {...getRootProps()} className={isDragActive ? (isDragAccept ? styles.dropzoneselect : styles.dropzoneinvalid) : styles.dropzone} >
                                                {getGridView()}
                                            </div>)}
                                    </Dropzone>
                                    :
                                    <>
                                        {getGridView()}
                                    </>
                                }
                            </div>

                            <Menu
                                open={contextMenu != null}
                                onClose={handleClose}
                                anchorReference="anchorPosition"
                                anchorPosition={
                                    contextMenu !== null
                                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                                        : undefined
                                }
                            >
                                <MenuItem disabled={contextMenu?.dataItem?.allowcopy == false || !contextMenu?.dataItem || contextMenu?.dataItem?.isfolder} onClick={handleCopy}>Copy</MenuItem>
                                <MenuItem disabled={contextMenu?.dataItem?.allowmove == false || !contextMenu?.dataItem || contextMenu?.dataItem?.isfolder} onClick={handleMove}>Cut</MenuItem>
                                <MenuItem disabled={copyDateItem === null} onClick={handlePaste}>Paste</MenuItem>
                                <MenuItem disabled={contextMenu?.dataItem?.allowrename == false || !contextMenu?.dataItem} onClick={handleRename}>Rename</MenuItem>
                                <MenuItem disabled={contextMenu?.dataItem?.allowdownload == false || !contextMenu?.dataItem || contextMenu?.dataItem?.isfolder} onClick={handleDownload}>Download</MenuItem>
                                <MenuItem disabled={contextMenu?.dataItem?.allowdelete == false || !contextMenu?.dataItem} onClick={handleDelete}>Delete</MenuItem>
                            </Menu>

                            {editDialogView
                                ? <EditDialog
                                    editValue={Object.keys(selectedGridItem).length ? selectedGridItem : selectedTreeItem}
                                    onDialogClose={handleDialogClose}
                                    onDialogClick={handleDialogClick}
                                />
                                : ''}
                            {deleteDialogView ? <DeleteDialog onDialogClose={handleDialogClose} onDialogClick={handleDialogClick} /> : ''}
                        </div>
                        <FileInformation data={detailsData} />
                    </Splitter>
                </div>
            </div>
            {/*}*/}

            {watchLogoDataURL && (
                <>
                    <Grid item xs={6} className={styles.selectcontrol}>
                        <>
                            <Alerts errorMsg={(uploadDocument.error as any)?.message} />
                            <Dialog
                                open={openViewer}
                                fullWidth={true}
                                maxWidth="xl"
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogContent>
                                    <div className="PDF-viewer">
                                        <PdfViewerComponent
                                            save={true}
                                            item={selectedGridItem}
                                            woid={woid}
                                            saveDocumentCallback={saveDocumentCallback}
                                            saveDocument={saveDocument}
                                            document={watchLogoDataURL}
                                        />
                                    </div>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => {
                                        setOpenViewer(false)
                                        setWatchLogoDataURL(null)
                                    }}>Close</Button>
                                    {/*<Button>Save</Button>*/}
                                </DialogActions>
                            </Dialog>
                        </>
                    </Grid>
                </>
            )}
        </div>
    );
}

